<!--
 * @Author: zxf
 * @Date: 2022-08-07 21:25:29
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:50:04
 * @Description: 评估数据推送
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        数据推送管理
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="120px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="报告编号"
                prop="bgbh"
              >
                <el-input
                  v-model.trim="filterParams.bgbh"
                  class="c-form__input"
                  placeholder="请输入报告编号"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #bgbh="scope"
            >
              <el-link
                type="primary"
                :disabled="scope.row.previewPdf"
                @click="(e)=>$utils.previewPdf(e,scope.row.bgUrl, scope.row)"
              >
                <i
                  v-show="scope.row.previewPdf"
                  class="el-icon-loading"
                />
                {{ scope.row.bgbh }}
              </el-link>
            </template>
            <!-- <template
              #gzztMc="scope"
            >
              <span
                :class="{
                  'u-text-success' : scope.row.gzztDm==='1',
                  'u-text-danger' : scope.row.gzztDm==='0'
                }"
              >
                {{ scope.row.gzztMc }}
              </span>
            </template> -->
            <template
              #qgxt="scope"
            >
              <div
                :class="{
                  'u-text-primary': scope.row.qgxt === '0',
                  'u-text-success': scope.row.qgxt === '1',
                  'u-text-danger': scope.row.qgxt === '2'
                }"
              >
                {{ scope.row.qgxt === '0'?'未推送': scope.row.qgxt === '1' ? '推送成功': '推送失败' }}
              </div>
            </template>
            <template
              #gdshpt="scope"
            >
              <div
                :class="{
                  'u-text-primary': scope.row.gdshpt === '0',
                  'u-text-success': scope.row.gdshpt === '1',
                  'u-text-danger': scope.row.gdshpt === '2'
                }"
              >
                {{ scope.row.gdshpt === '0'?'未推送': scope.row.gdshpt === '1' ? '推送成功': '推送失败' }}
              </div>
            </template>
            <!-- <template
              #lwdwpt="scope"
            >
              <div
                :class="{
                  'u-text-primary': scope.row.lwdwpt === '0',
                  'u-text-success': scope.row.lwdwpt === '1',
                  'u-text-danger': scope.row.lwdwpt === '2'
                }"
              >
                {{ scope.row.lwdwpt === '0'?'未推送': scope.row.lwdwpt === '1' ? '推送成功': '推送失败' }}
              </div>
            </template> -->
            <el-table-column
              prop="enabled"
              label="操作"
              width="250"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  v-if="scope.row.gdshpt === '0' || scope.row.gdshpt === '2'"
                  btn-text="推送广东平台"
                  :auth-type="true"
                  type="primary"
                  icon="el-icon-monitor"
                  plain
                  @click="handleGdpt(scope.row)"
                />
                <!-- <k-button
          btn-text="推送全国系统"
:auth-type="true"
                  v-if="scope.row.qgxt === '0' || scope.row.qgxt === '2'"
                  type="primary"
                  icon="el-icon-s-platform"
                  plain
                  @click="handleQgxt(scope.row)"
                >

                </k-button> -->
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->
  </div>
</template>

<script>
import { bgglManageService } from './bggl.service';

export default {
  name: 'JcsjtsIndex',
  data () {
    return {
      loading: false, // 页面是否loading状态

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmmc: null, // 项目名称
        bgbh: null, // 报告编号
        bgType: 'BGTS'
      },
      /* 查询条件 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'left', minWidth: '220', type: 'text' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '220', type: 'text' },
        { key: 'wtdw', label: '委托单位', align: 'left', minWidth: '130', type: 'text' },
        { key: 'xmztMc', label: '状态', align: 'center', width: '130', type: 'text' },
        { key: 'qgxt', slotName: 'qgxt', label: '全国系统', align: 'left', width: '130', type: 'text' },
        { key: 'gdshpt', slotName: 'gdshpt', label: '广东社会平台', align: 'left', width: '130', type: 'text' }

      ]
      /* 表格列配置End */

    };
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      bgglManageService.Sjtsquery(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 推送到广东平台
     * @return {*}
     */
    handleGdpt (_row) {
      console.log(_row);
      this.loading = true;
      bgglManageService.updateGdpt(_row.id)
        .then(rsp => {
          this.$alert('推送成功', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
              _row.gdshpt = '1';
            }
          });
        })
        .catch(err => {
          console.error('推送到广东平台错误！', err);
          _row.gdshpt = '2';
        }).finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 推送到全国系统
     * @return {*}
     */
    handleQgxt (_row) {
      this.loading = true;
      bgglManageService.updateQgxt(_row.id)
        .then(rsp => {
          this.$alert('推送成功', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
              _row.qgxt = '1';
            }
          });
        })
        .catch(err => {
          console.error('推送到全国系统错误！', err);
          _row.qgxt = '2';
        }).finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
